import { baseApi } from './base.api'

export const cerrarSesionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Notifica al backend el cierre de sesion antes de limpiar tokens locales en `useLogout`.
     */
    cerrarSesion: builder.mutation({
      query() {
        return {
          url: `${window._env_.API_CONTEXTO_LOGOUT}`,
          method: 'POST',
        }
      },
    }),
  }),
})

export const { useCerrarSesionMutation } = cerrarSesionApi
